import { h } from "preact";

function PauseCircleIcon(props) {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke={props.color || 'currentColor'}
    stroke-width={props.strokeWidth || 1}
    stroke-linecap="round"
    stroke-linejoin="round"
    className={props.className || 'feather feather-pause-circle'}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="10" y1="15" x2="10" y2="9" />
      <line x1="14" y1="15" x2="14" y2="9" />
    </svg>
  );
}

export default PauseCircleIcon
